import { Headers } from '@egw/components'
import { CheckingActivityPage } from '@egw/features-transactions'
import { useTranslation } from '@egw/i18n'
import { Layout } from '@egw/layouts'
import { type FC } from 'react'
import { useParams } from 'react-router'

export const CheckingAccountActivityPage: FC = () => {
  const { t } = useTranslation()

  const { alias } = useParams<{ alias: string }>()

  return alias ? (
    <Layout>
      <Headers title={t('pages.checking.title')} />
      <CheckingActivityPage alias={parseInt(alias)} />
    </Layout>
  ) : null
}
